module.exports = __webpack_public_path__ + "img/eventtype-warning.64a05597.svg";